import { Link } from "@mui/material";

type PhoneLinkProps = {
  phone?: string | null;
  empty?: string;
  stopPropagation?: boolean;
};

export default function PhoneLink({ phone, empty = "—", stopPropagation = false }: PhoneLinkProps) {
  const value = phone?.trim() || "";

  if (!value) {
    return <>{empty}</>;
  }

  return (
    <Link
      href={`tel:${value}`}
      underline="hover"
      onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
    >
      {value}
    </Link>
  );
}
